<template>
  <div class="container-fluid">
    <div id="charts" class="mt--5 mb-5 card mx-5 p-3">
      <h2 class="mx-auto">Número de inscrições por dia</h2>
      <apexchart
        class="mx-auto"
        width="900"
        height="400"
        type="bar"
        :options="options"
        :series="series"
      ></apexchart>
    </div>
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import api from "@/services/api";
export default {
  name: "metrics-inscricoes",
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    startupCallId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      options: {
        chart: {
          id: "vuechart-example",
        },
        xaxis: {
          categories: [],
        },
      },
      series: [],
    };
  },
  async mounted() {
    const loaderForm = this.$loading.show({
      container: this.$refs.charts,
      width: 90,
      height: 90,
    });
    try {
      const { data } = await api.get(
        `/adm/startup-calls/${this.startupCallId}/subscriptionsCount`
      );
      this.series.push({
        name: "inscritos",
        data: data.map((item) => item.count),
      });
      const newOptions = {
        chart: {
          id: "vuechart-example",
        },
        xaxis: {
          categories: data.map((item) =>
            this.moment(item.date, "YYYY-MM-DD").format("DD/MM/YYYY")
          ),
        },
      };
      this.options = newOptions;
    } catch (error) {
      this.$toasted.error("Erro ao recuperar as informações");
      console.log(error);
    } finally {
      loaderForm.hide();
    }
  },
  methods: {},
};
</script>
<style></style>
